import { z } from 'zod';

export const PalavraSchema = z.object({
  p: z.string(),
  i: z.number().int().nonnegative(),
  f: z.number().int().nonnegative(),
});
export type Palavra = z.infer<typeof PalavraSchema>;

export const SegmentoTranscricaoSchema = z.object({
  id: z.string(),
  gravacaoId: z.string(),
  seq: z.number().int().nonnegative(),
  inicioMs: z.number().int().nonnegative(),
  fimMs: z.number().int().nonnegative(),
  texto: z.string(),
  palavras: z.array(PalavraSchema),
  confianca: z.number().nullable(),
});
export type SegmentoTranscricao = z.infer<typeof SegmentoTranscricaoSchema>;


export * from './cortes';
export * from './mesclar';
export * from './filtros';
